export class LocalPermission {
    id?: number;

    constructor(init?: Partial<LocalPermission>) {
        Object.assign(this, init);
    }
}
